import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { fetchSetting, sendMessageApi } from "../../api/api";
import "./contectus.css";

const ContactUs = () => {
  const [setting, setSetting] = useState({ phone: "" });
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      try {
        const s = await fetchSetting();
        if (s) setSetting(s);
      } catch (_) {}
    })();
  }, []);

  const onSubmit = async (data) => {
    try {
      const phone = String(setting?.phone || "").replace(/\D/g, "");
      const text = encodeURIComponent(
        `Hola, necesito soporte.%0A%0ANombre: ${data.name}%0AEmail: ${data.email}%0AMensaje: ${data.message}`
      );
      const base = phone ? `https://wa.me/${phone}` : `https://wa.me/`;
      window.open(`${base}?text=${text}`, "_blank");
      try { await sendMessageApi(data); } catch (_) {}
      reset();
    } catch (_) {}
  };

  return (
    <div className="contact-minimal pading150">
      <h1 className="contact-minimal-title">¿Necesitás soporte? Envíanos un mensaje</h1>
      <p className="contact-minimal-subtext">
        Contanos el motivo de tu consulta y un asesor se pondrá en contacto con vos
        <span className="only-desktop">. Estamos para asistirte</span>
      </p>

      <div className="contact-minimal-card">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="Nombre"
              className="contact-minimal-input"
              {...register("name", { required: "Ingresá tu nombre" })}
            />
            {errors.name && <div className="field-error">{errors.name.message}</div>}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Control
              type="email"
              placeholder="Email"
              className="contact-minimal-input"
              {...register("email", { required: "Ingresá tu email" })}
            />
            {errors.email && <div className="field-error">{errors.email.message}</div>}
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Mensaje"
              className="contact-minimal-input"
              {...register("message", { required: "Escribí tu mensaje" })}
            />
            {errors.message && <div className="field-error">{errors.message.message}</div>}
          </Form.Group>

          <div className="contact-minimal-btn-wrap">
            <button type="submit" className="contact-minimal-btn">
              <span className="wa-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.52 3.48A11.935 11.935 0 0 0 12 0C5.373 0 0 5.373 0 12c0 2.111.548 4.182 1.588 6.01L0 24l6.153-1.566A11.93 11.93 0 0 0 12 24c6.627 0 12-5.373 12-12 0-3.19-1.244-6.188-3.48-8.52ZM12 22.001a9.96 9.96 0 0 1-5.08-1.393l-.364-.214-3.633.925.97-3.54-.237-.372A9.957 9.957 0 0 1 2 12C2 6.486 6.486 2 12 2c2.668 0 5.182 1.04 7.07 2.929C20.96 6.818 22 9.332 22 12c0 5.514-4.486 10.001-10 10.001Zm5.204-7.58c-.285-.143-1.684-.83-1.944-.924-.26-.095-.45-.143-.64.143-.19.285-.734.924-.9 1.114-.167.19-.334.214-.62.071-.285-.143-1.204-.444-2.293-1.417-.848-.756-1.42-1.69-1.587-1.975-.167-.285-.018-.439.125-.582.128-.128.285-.334.428-.5.143-.167.19-.285.285-.476.095-.19.047-.357-.024-.5-.071-.143-.64-1.54-.876-2.11-.23-.553-.465-.478-.64-.486-.167-.008-.357-.01-.547-.01-.19 0-.5.071-.762.357-.262.285-1.002.978-1.002 2.386s1.026 2.768 1.169 2.957c.143.19 2.02 3.086 4.89 4.325.683.294 1.215.47 1.63.603.685.218 1.31.188 1.803.114.55-.082 1.684-.69 1.922-1.357.238-.666.238-1.237.167-1.357-.071-.119-.262-.19-.547-.333Z" fill="#25D366"/>
                </svg>
              </span>
              Continuar por WhatsApp
            </button>
          </div>
          <div className="contact-minimal-note">
            Al continuar, aceptás nuestra <a href="/privacypolicy">Política de Privacidad</a>.
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ContactUs;

